import classnames from 'classnames';
import React from 'react';

import { onKeyPress } from '../../utils/keypress';

import styles from './index.module.css';

export enum CheckMarkTypes {
  CHECKMARK,
  RADIO,
  ROUNDCHECKMARK,
}

interface Props {
  invertColors?: boolean;
  value?: string;
  label?: React.ReactNode;
  checked?: boolean;
  type?: CheckMarkTypes;
  onClick?: () => void;
  className?: string;
  id?: string;
}

export const CheckMark: React.FC<Props> = (props) => {
  const {
    invertColors = false,
    onClick,
    label,
    checked,
    value,
    type = CheckMarkTypes.CHECKMARK,
    className,
    id,
  } = props;
  const containerProps: React.HTMLAttributes<HTMLDivElement> = {
    className: [styles.Container, !onClick ? styles.Static : '', className]
      .filter((x) => !!x)
      .join(' '),
  };
  if (onClick) {
    containerProps.onClick = onClick;
  }
  return (
    <div {...containerProps}>
      <input
        type="radio"
        value={value}
        checked={checked}
        readOnly={true}
        tabIndex={-1}
      />
      <span
        id={id}
        className={classnames({
          [styles.RadioButton]: type === CheckMarkTypes.RADIO,
          [styles.CheckMark]: type === CheckMarkTypes.CHECKMARK,
          [styles.InvertedColors]: invertColors,
          [styles.RoundCheck]: type === CheckMarkTypes.ROUNDCHECKMARK,
        })}
        role={type === CheckMarkTypes.RADIO ? 'radio' : 'checkbox'}
        aria-checked={checked ? 'true' : 'false'}
        tabIndex={1}
        aria-label={
          label && !React.isValidElement(label) ? `${label}` : undefined
        }
        onKeyDown={(e) => onKeyPress({ e, onConfirm: onClick })}
      />
      {label ? <label htmlFor={id}>{label}</label> : null}
    </div>
  );
};
